import { moment } from '../../util/date'

/**
 * Create `intl` instance with default implementations based on moment.js and
 * the DatePicker's locale.
 *
 * @param {string} locale
 * @return {object} { formatDate: function, formatDateOnly: function, formatTimeOnly: function }
 */
export function createDefaultIntl(locale) {
    return {
        formatDate(date) {
            if (date) {
                return createMoment(date, locale).format('L, LT')
            } else {
                const datePattern = getLocaleData(locale).longDateFormat('L')
                const timePattern = getLocaleData(locale).longDateFormat('LT')

                // Something like 'MM/DD/YYYY, hh:mm'
                return `${datePattern}, ${timePattern}`
            }
        },

        formatDateOnly(date) {
            return date ? createMoment(date, locale).format('L') : getLocaleData(locale).longDateFormat('L') // Something like 'MM/DD/YYYY'
        },

        formatTimeOnly(date) {
            return date ? createMoment(date, locale).format('LT') : getLocaleData(locale).longDateFormat('LT') // Something like 'hh:mm'
        },

        getLocale() {
            return locale
        }
    }
}

function createMoment(value, locale) {
    return locale ? moment(value).locale(locale) : moment(value)
}

function getLocaleData(locale) {
    return locale ? moment().localeData(locale) : moment().localeData()
}
